const TYPES = {
  ICubeControllerFactory: Symbol.for('ICubeControllerFactory'),
  ICubeButtonsController: Symbol.for('ICubeButtonsController'),
  ICubeSceneController: Symbol.for('ICubeSceneController'),
  ICubePresentationBuilder: Symbol.for('ICubePresentationBuilder')
};

export { TYPES };
